<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button [defaultHref]="cartRouteUrl"></ion-back-button>
        </ion-buttons>
        <ion-title>{{ 'payment' | transloco }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="main-content">
        <div class="card">
            <div class="card-header">
                <h5 class="card-title">{{ 'bill' | transloco }}</h5>
            </div>
            <div class="card-content">
                <us-order-items class="grid grid-cols-1 divide-y divide-gray-50" [order]="cart()" [readonly]="true">
                </us-order-items>
                <div class="flex-none border-t border-gray-200">
                    <div class="pt-4 flex flex-col gap-4">
                        <div class="flex items-end justify-between text-base">
                            <span>
                                <span class="font-semibold block">{{ 'total_payment' | transloco }}</span>
                                <!--<span class="text-xs text-gray-500 mt-2 block">
                                                {{ 'tax_included_if_any' | transloco }}
                                            </span>-->
                            </span>
                            <span class="font-semibold text-gray-900 block">
                                {{ cart().grand_total || 0 | formatCurrency }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h5 class="mb-3 card-title text-lg mt-8">{{ 'payment_methods' | transloco }}</h5>

        <us-payment-type-options [options]="paymentMethods()" [(value)]="paymentType"></us-payment-type-options>
    </div>
</ion-content>

<ion-footer>
    <div class="main-content" [ngClass]="{'bg-white': isFnb}">
        <button
            tuiButton
            class="w-full"
            [disabled]="paymentType === null"
            [showLoader]="loading()"
            (click)="onSubmit()"
        >
            {{ 'pay' | transloco }}&nbsp;
            <span class="font-bold">{{ total() | formatCurrency }} </span>
        </button>
    </div>
</ion-footer>
